import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { debounce } from "../../Common/debounce";
import { Loader } from "../../Common/Loader";
import { Pagination } from "../../Common/Pagination";
import { Table } from "../../Common/Table";
import useDebounce from "../../Common/useDebounce";
import { getAllCompanyWithAssistantCount } from "../../Redux/Slice/Assistant/GetAllCompanyWithAssistantCountSlice";
import {
  resetPagination,
  setPage,
  setTotalItems,
  setTotalPages,
} from "../../Redux/Slice/Common/PaginationSlice";
import { LIMIT_PER_PAGE } from "../../Common/Constants";

const ViewAssistants = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [localItemsPerPage, setLocalItemsPerPage] = useState(LIMIT_PER_PAGE);
  const { companiesWithAssistantCountData, loading } = useSelector(
    (state) => state.companyWithAssistantCount
  );

  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 500);

  const formattedCountData = useMemo(() => {
    if (
      Array.isArray(companiesWithAssistantCountData?.data?.response) &&
      companiesWithAssistantCountData?.data?.response?.length
    ) {
      return companiesWithAssistantCountData?.data?.response?.map((item) => ({
        ...item,
        name: `${item?.firstName ? item?.firstName : ""}${
          item?.lastName ? " " + item?.lastName : ""
        }`,
      }));
    }
    return [];
  }, [JSON.stringify(companiesWithAssistantCountData)]);

  const getCallHistoryData = async (page = 1, limit) => {
    const result = await dispatch(
      getAllCompanyWithAssistantCount({ searchText, page, limit })
    );
    dispatch(setPage(result?.payload?.data?.pagination?.currentPage));
    dispatch(setTotalItems(result?.payload?.data?.pagination?.totalItems));
    dispatch(setTotalPages(result?.payload?.data?.pagination?.totalPages));
  };

  const debouncedGetHistoryList = useCallback(
    debounce(getCallHistoryData, 500),
    [searchQuery]
  );

  useEffect(() => {
    debouncedGetHistoryList(1, localItemsPerPage);
  }, [searchQuery, debouncedGetHistoryList]);

  useEffect(() => {
    dispatch(resetPagination());
    getCallHistoryData();
  }, []);

  const columns = [
    {
      label: "Company Name",
      key: "companyName",
      avatarKey: "logo",
      className: "profile__link",
    },
    {
      label: "Admin Name",
      key: "name",
      className: "cellText",
    },
    {
      label: "No. of Assistants",
      key: "assistantCount",
      className: "cellText",
    },
  ];

  return (
    <>
      <div className="page__body">
        {loading ? <Loader /> : null}
        <div className="tableWrap">
          <div className="tableWrap__head tableWrap__head--wrap">
            <div className="formRow m_0 w_100 formRow--flexEnd">
              <div className="formCol formCol--flex">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value.trimStart());
                    }}
                    spellCheck="false"
                    placeholder="Search by Company Name, Admin Name"
                  />
                </div>
              </div>
            </div>
          </div>
          <Table
            data={formattedCountData}
            columns={columns}
            onClickLink={(rowData) =>
              navigate(`/assistants/${rowData?.customerId}`, {
                state: {
                  planType: rowData?.planType,
                  customerName: rowData?.companyName,
                },
              })
            }
            noDataMsg={
              searchQuery && searchQuery?.length
                ? `No Assistant Found!`
                : `No Assistant!`
            }
          />
        </div>
      </div>
      <Pagination
        apiMethod={getCallHistoryData}
        itemsPerPage={localItemsPerPage}
        setItemsPerPage={setLocalItemsPerPage}
      />
    </>
  );
};

export default ViewAssistants;
